<app-header></app-header>
<main class="timeapp" style="display: flex;  flex-direction: column; overflow: hidden;">
	<div style="position:relative;">
		<div style="position: absolute; top: 1em; right: 1em;">
		
		</div>
	</div>
	
	<div style="display: flex; justify-content: center; padding: 1em 0 0 0;">
		<mat-button-toggle-group aria-label="Font Style" name="fontStyle" value="edit">
			<mat-button-toggle value="kamera">
				<label for="files" style="margin: 0; padding: 0">{{ "HOME.Kamera" | translate }}
					<input (change)="openCamera($event)" accept="image/*" capture="environment" id="files" multiple style="visibility: hidden; display: none" type="file"/>
				</label>
			</mat-button-toggle>
			<mat-button-toggle value="imageUpload">
				<label for="imageUpload" style="margin: 0; padding: 0">{{ "HOME.Hochladen" | translate }}
					<input (change)="openCamera($event)" accept="image/png, image/jpeg" id="imageUpload" multiple style="visibility: hidden; display: none" type="file"/>
				</label>
			</mat-button-toggle>
		</mat-button-toggle-group>
	</div>
	
	<div style="display: flex; justify-content: center; padding: 1em 0 0 0;">
		<mat-checkbox (change)="switchView()">
			{{ 'MAIN_APP_TIME.DAY_VIEW.text' | translate }}
		</mat-checkbox>
	</div>
	
	<ng-container [ngSwitch]="view">
		<ng-container *ngSwitchCase="'OrderView'" [ngTemplateOutlet]="orderView"></ng-container>
		<ng-container *ngSwitchDefault [ngTemplateOutlet]="dayView"></ng-container>
	</ng-container>
	
	<ng-template #orderView>
		<div style="display: flex; justify-content: center; overflow: hidden;">
			<div style="display: flex; flex-direction: column; row-gap: 1em; overflow-y: scroll; width: 100%; align-items: center; padding: 1em 0;">
				<div *ngFor="let item of orderImages | async; let last = last" [ngClass]="{'synced': item.synced }" style="padding: 1em; background-color: rgba(0,0,0,0.2); border-radius: 1em;">
					<div *ngIf="item.synced" style="position: relative; top: 5px; left:5px">
						<div style="position: absolute; width: 2em; height: 2em; background-color: rgba(0,0,0,0.5); border-radius: 100px; display: flex;    justify-content: center;    align-items: center;">
							<fa-icon (click)="desyncImage(item)" [icon]="faBolt" style="font-size: 1.5em;"></fa-icon>
						</div>
					</div>
					<img [src]="item?.data" alt="image" class="imageSize" style="display: flex;">
					<div style="display: flex; flex-direction: column; text-align: center; padding: 1em 0;">
						<div>{{ item?.fileName }}</div>
						<div>{{ item?.description }}</div>
					</div>
					
					<div class="iconContainer" style="justify-content: center; display: flex;">
						<button (click)="editImg(item)" [disabled]="item.synced" mat-mini-fab style="background-color: #ffffff;">
							<mat-icon>brush</mat-icon>
						</button>
						<!-- TOD0 2025-10-08 EN-4006 - Disabled due to ios bug Images are send weirdly once description has been changed
						<button (click)="editDescription(item)" [disabled]="item.synced" mat-mini-fab style="background-color: #ffffff;">
							<mat-icon>edit_document</mat-icon>
						</button>-->
						<button (click)="openDeleteDialog(item)" [disabled]="item.synced" mat-mini-fab style="background-color: #ffffff;">
							<mat-icon>delete</mat-icon>
						</button>
						<button (click)="downloadImage(item)" *ngIf="(debugMode | async)" mat-mini-fab style="background-color: #ffffff;">
							<mat-icon>download</mat-icon>
						</button>
					</div>
				</div>
			</div>
		</div>
	</ng-template>
	
	<ng-template #dayView>
		<div style="display: flex; justify-content: center; overflow: hidden;">
			<div style="display: flex; flex-direction: column; row-gap: 1em; overflow-y: scroll; width: 100%; align-items: center; padding: 1em 0;">
				<div *ngFor="let item of dayImages | async; let last = last" [ngClass]="{'synced': item.synced }" style="padding: 1em; background-color: rgba(0,0,0,0.2); border-radius: 1em;">
					<div *ngIf="item.synced" style="position: relative; top: 5px; left:5px">
						<div style="position: absolute; width: 2em; height: 2em; background-color: rgba(0,0,0,0.5); border-radius: 100px; display: flex;    justify-content: center;    align-items: center;">
							<fa-icon (click)="desyncImage(item)" [icon]="faBolt" style="font-size: 1.5em;"></fa-icon>
						</div>
					</div>
					<img [src]="item?.data" alt="image" class="imageSize" style="display: flex;">
					<div style="display: flex; flex-direction: column; text-align: center; padding: 1em 0;">
						<div>{{ item?.fileName }}</div>
						<div>{{ item?.objectName }}</div>
						<div>{{ item?.description }}</div>
					</div>
					
					<div class="iconContainer" style="justify-content: center; display: flex;">
						<button (click)="editImg(item)" [disabled]="item.synced" mat-mini-fab style="background-color: #ffffff;">
							<mat-icon>brush</mat-icon>
						</button>
						<!-- TOD0 2025-10-08 EN-4006 - Disabled due to ios bug Images are send weirdly once description has been changed
						<button (click)="editDescription(item)" [disabled]="item.synced" mat-mini-fab style="background-color: #ffffff;">
							<mat-icon>edit_document</mat-icon>
						</button>
						-->
						<button (click)="openDeleteDialog(item)" [disabled]="item.synced" mat-mini-fab style="background-color: #ffffff;">
							<mat-icon>delete</mat-icon>
						</button>
						<button (click)="downloadImage(item)" *ngIf="(debugMode |async)" mat-mini-fab style="background-color: #ffffff;">
							<mat-icon>download</mat-icon>
						</button>
					</div>
				</div>
			</div>
		</div>
	</ng-template>
</main>
<footer class="timeapp">
	<a routerLink="/timeapp" style="color: white;">
		<mat-icon class="icon-size">
			arrow_back
		</mat-icon>
	</a>
</footer>
